var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDependency, useLucidSdk } from '#context';
import { FilespacesKeyFactory, WorkspacesKeyFactory } from '#query-hooks';
export const useFilespaceDelete = ({ onError, onSuccess, } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const queryClient = useQueryClient();
    const { mutation: { mutateAsync: filespaceQuit }, } = useDependency('useFilespaceQuit')();
    const mutation = useMutation({
        mutationFn: async ({ code, filespaceData: { id, name, workspaceId }, }) => {
            await lucidSdk
                .workspaceClient(workspaceId)
                .deleteFilespace(id, { code });
            // Disconnect after confirmation from BE that code is valid
            await filespaceQuit({
                filespaceId: id,
                workspaceId,
                filespaceName: name,
            });
        },
        onSuccess: async (_, { filespaceData: { workspaceId } }) => {
            try {
                await Promise.all([
                    // Update filespace list
                    queryClient.refetchQueries({
                        queryKey: FilespacesKeyFactory.byWorkspace(workspaceId),
                        exact: true,
                    }),
                    // Update all workspaces data
                    // So we know if the user is
                    // allowed or not to create more FS
                    queryClient.refetchQueries({
                        queryKey: WorkspacesKeyFactory.all(),
                    }),
                ]);
            }
            finally {
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
            }
        },
        onError: (error) => {
            if (typeof onError === 'function') {
                onError(error);
            }
        },
        networkMode: 'always',
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useFilespaceDelete, "M0XP5yS2MdPkCBnwnsddfgvGc5k=", false, () => [useLucidSdk, useQueryClient, useDependency, useMutation]);
